import { GALLERY_ITEMS_INITIAL_STATE } from './galleryItemsInitialState';

const initialState = GALLERY_ITEMS_INITIAL_STATE;

export default function galleryItems(state = initialState, action = {}) {
  return state;
}